import * as React from "react";
import RideFilter from "../ride/rideFilter/RideFilter";
import BookingDataAccessCheck from "../shared/components/bookingDataAccessCheck/BookingDataAccessCheck";
import GreyResultBackground from "../shared/components/greyResultBackground/GreyResultBackground";
import PartnerHeadline from "../shared/components/partnerHeadline/PartnerHeadline";
import BookingInfoBody from "./containers/bookingInfoBody/BookingInfoBody";

const BookingInfo: React.FC = () => {
  return (
    <BookingDataAccessCheck>
      <PartnerHeadline headline="Booking Reports" />
      <RideFilter showCompletedRideFilterInPopup={false} />
      <GreyResultBackground>
        <BookingInfoBody />
      </GreyResultBackground>
    </BookingDataAccessCheck>
  );
};

export default BookingInfo;
